<template>
  <v-container
    fluid
  >
    <v-row>
      <v-col
        cols="12"
        xs="12"
        sm="12"
        md="6"
        lg="6"
        xl="6"
      >
        <Postfach></Postfach>
      </v-col>
      <v-col
        cols="12"
        xs="12"
        sm="12"
        md="6"
        lg="6"
        xl="6"
      >
        <v-card
          :disabled="sending"
          :loading="sending"
        >
          <v-card-title>
            SDS-Editor
            <v-spacer></v-spacer>
            <v-btn
              icon
              @click="reset_newsds"
            >
              <v-icon>
                mdi-close
              </v-icon>
            </v-btn>
          </v-card-title>
          <v-card-subtitle>
            Nachrichten werden vom Stadtfeuerwehrserver mit der Kennung {{ $store.state.device.display_name }} gesendet.
          </v-card-subtitle>
          <v-card-text
          >
              <v-row>
                <v-col
                  cols="12"
                >
                  <v-autocomplete
                    v-model="new_sds.receiver"
                    chips
                    multiple
                    :items="get_issis"
                    :item-text="item => (item.display_name.length == 0) ? item.issi : item.display_name +' ('+ item.issi + ')'"
                    item-value="issi"
                    clearable
                    deletable-chips
                    hide-no-data
                    label="Empfänger"
                    hint="Filteroptionen: OPTA, ISSI oder Beschreibung"
                    persistent-hint
                    :filter="onFilter"
                    :search-input.sync="searchinput"
                  >
                    <!-- <template
                      v-slot:prepend-item>
                      <v-list-item
                        ripple
                      >
                        <v-list-item-action>
                          <v-icon>
                            mdi-checkbox-blank-outline
                          </v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                          Alle angezeigten markieren

                        </v-list-item-content>
                      </v-list-item>
                      <v-divider></v-divider>
                    </template> -->
                  </v-autocomplete>
                </v-col>
                <v-col
                  cols="12"
                >
                  <v-textarea
                    v-model="new_sds.text"
                    ref="textbox"
                    :rules="validate_sds_text"
                    :hint="new_sds.text.length + ' von 85 Zeichen.'"
                    persistent-hint
                    no-resize
                    maxlength="85"
                  >
                  </v-textarea>
                </v-col>
                <v-col
                  cols="3"
                >
                  <v-switch
                    v-model="new_sds.flash_sds"
                    label="Flash SDS"
                    hide-details
                  ></v-switch>
                </v-col>
                <v-col
                  cols="9"
                >
                  <v-switch
                    v-model="new_sds.copy_to_station"
                    :label="(new_sds.copy_to_station) ? 'Kopie an Wache: ' + this.get_stations_to_engines_text : 'Kopie an Wache'"
                    hide-details
                  ></v-switch>
                </v-col>
                <v-col
                  cols="12"
                >
                  Vorlagen:
                  <v-chip
                    class="ml-1"
                    @click="new_sds = {receiver: new_sds.receiver, text: '*adresse *Baum *Stärke und Abrücken an ELO melden!', flash_sds: true, copy_to_station: true}"                  >
                    Neuer Einsatz
                  </v-chip>
                  <v-chip
                    class="ml-1"
                    @click="new_sds = {receiver: new_sds.receiver, text: 'Bei ELO melden!', flash_sds: true, copy_to_station: new_sds.copy_to_station}"
                  >
                    Bei ELO melden!
                  </v-chip>
                  <v-chip
                    class="ml-1"
                    @click="new_sds = {receiver: new_sds.receiver, text: 'Stärke an ELO melden', flash_sds: true, copy_to_station: new_sds.copy_to_station}"
                  >
                    Stärke melden!
                  </v-chip>
                </v-col>
              </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              class="primary"
              style="float: right"
              :disabled="new_sds.receiver.length == 0 || new_sds.text.length == 0 || new_sds.text.length > 85 || ! new RegExp(sz_checker_string).test(new_sds.text)"
              :loading="sending"
              @click="send_sds"
            >
              <v-icon
                class="mx-1"
              >
                mdi-send
              </v-icon>
              Senden
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Postfach from "../components/MessageCenter/Postfach";
export default {
  name: "SDSCenter",
  components: { Postfach },
  data: () => ({
    searchinput: null,
    show_eingehende: true,
    show_ausgehende: true,
    new_sds: {
      receiver: [],
      text: '',
      flash_sds: false,
      copy_to_station: false
    },
    sz_checker_string: /^[a-zA-Z0-9,.:!?*+-/%/\s&üöäÜÖÄß]*$/,
    sending: false,

    blink_source: false,
    blink_interval: null
  }),
  created() {
    /*if(this.$store.state.engines.engine_list == null){
      this.$store.dispatch("update", { "context": "/engines" })
    }*/
    /*if(this.$store.state.message_center.messages == null || this.$store.state.message_center.messages.length == 0){
      this.$store.dispatch("update", { "context": "message/list" })
    }*/
  },
  mounted() {
    if(this.$route.query.issi && this.$route.query.issi.length == 7){
      this.new_sds.receiver.push(this.$route.query.issi)
    }
    let thiis = this
    this.blink_interval = setInterval(function() {
      thiis.blink_source = !thiis.blink_source
    }, 500)
  },
  methods: {
    formate_time(timestamp) {
      let date = new Date(timestamp * 1000)
      let hh = date.getHours();
      let mm = date.getMinutes();
      let ss = date.getSeconds();

      hh = (hh < 10) ? "0" + hh : hh;
      mm = (mm < 10) ? "0" + mm : mm;
      ss = (ss < 10) ? "0" + ss : ss;

      return hh + ":" + mm + ":" + ss;
    },
    onFilter(engine, queryText) {
      return engine.display_name.toLowerCase().includes(queryText.toLowerCase()) || engine.issi.toLowerCase().includes(queryText.toLowerCase()) || engine.tags.toLowerCase().includes(queryText.toLowerCase())
    },
    reset_newsds() {
      this.new_sds = {
        receiver: [],
        text: '',
        flash_sds: false,
        copy_to_station: false
      }
    },
    mark_as_read(id){
      this.$store.dispatch("update", { "context": "/messages/read/" + id})
    },
    send_sds() {
      this.sending = true
      let issis = ''
      for (let index in this.new_sds.receiver) {
        let issi = this.new_sds.receiver[index]
        issis += issi + ";"
      }
      if(this.new_sds.copy_to_station) {
        for (let index in this.get_stations_to_engines_issis) {
          let issi = this.get_stations_to_engines_issis[index]
          issis += issi + ";"
        }
      }
      if (issis.endsWith(";")) {
        issis = issis.substring(0, issis.length - 1)
      }
      let sds = this.new_sds
      this.$store.dispatch("update", { "context": "/messages/send?" + 'destSSIs=' + encodeURIComponent(issis) + '&text=' + encodeURIComponent(sds.text) + '&flash_sds=' + sds.flash_sds + '&copy_to_station=' + sds.copy_to_station })

      let thiis = this
      setTimeout(function() {
        thiis.sending = false;
        thiis.reset_newsds();
      }, 800)
    }
  },
  computed: {
    validate_sds_text(){
      let sz_checker = new RegExp(this.sz_checker_string)
      return [v => sz_checker.test(v) || 'Sondereichen sind nicht erlaubt!']
    },
    get_stations_to_engines_issis(){
      let issis = []
      for(let index in this.new_sds.receiver){
        if(this.new_sds.receiver[index] in this.get_Engine_by_ISSI){
          let engine = this.get_Engine_by_ISSI[this.new_sds.receiver[index]]
          if(engine.station != null && engine.station.length > 0){
            let station_key = engine.station
            if(station_key in this.$store.state.issis){
              if(this.$store.state.issis[station_key].issi != null && this.$store.state.issis[station_key].issi.length == 7){
                let issi = this.$store.state.issis[station_key].issi
                if(!issis.includes(issi) && !this.new_sds.receiver.includes(issi)){
                  issis.push(issi)
                }
              }
            }
          }
        }
      }
      return issis
    },
    get_stations_to_engines_text(){
      let array = this.get_stations_to_engines_issis
      let text = ''
      for(let index in array){
        let issi = array[index]
        if(issi in this.get_Engine_by_ISSI) {
          text += this.get_Engine_by_ISSI[issi].display_name + ", "
        }
        else  {
          text += issi + ", "
        }
      }
      if(text.endsWith(", ")){
        text = text.substring(0, text.length-2)
      }
      return text
    },
    get_issis() {
      let customItems = []
      for(let index in this.new_sds.receiver){
        let issi = this.new_sds.receiver[index]
        if(this.get_Engine_by_ISSI[issi] == null){
          customItems.push({'display_name': "", "issi": issi, 'tags': ''})
        }
      }
      let storeItems = Object.keys(this.$store.state.issis).map((key) => this.$store.state.issis[key]).filter(engine => engine.issi != null && engine.issi.length == 7);
      return customItems.concat(storeItems)
    },
    get_Engine_by_ISSI() {
      let answer = {}
      for (let key in this.$store.state.issis) {
        let engine = this.$store.state.issis[key]
        if ('issi' in engine) {
          answer[engine.issi] = engine
        }

      }
      return answer
    },
    receiver_has_invalid_item(){
      return this.new_sds.receiver.filter(issi => issi.length != 7).length > 0
    }
  },
  watch: {
    searchinput: {
      handler(val) {
        if(val != null && val.length == 7 && /^\d+$/.test(val)){
          this.new_sds.receiver.push(val)
          this.searchinput = null
        }
      }
    }
  },
  destroyed() {
    clearInterval(this.blink_interval)
  }
}
</script>

